import { TargetingFields, type TargetingState } from '@openx/types/targeting/targeting';

export const hasContextualSegments = (targeting?: Partial<TargetingState>): boolean =>
  Boolean(targeting?.[TargetingFields.CONTEXTUAL_SEGMENTS]?.length);
